import React, { Component, Fragment } from 'react'
import {StaticQuery, graphql, useStaticQuery} from 'gatsby'
import TechnicalIcon from './TechnicalIcon'

const queryWrapper = ({ imageUrl }) => {
  const data = useStaticQuery(graphql`
    query TechIconImageQuery {
      allFile(
        filter: { relativeDirectory: { regex: "images/projects/icons/" } }
      ) {
        edges {
          node {
            id
            absolutePath
            publicURL
            childImageSharp {
              id
              internal {
                contentDigest
                type
                owner
              }
              fixed(width: 52) {
                ...GatsbyImageSharpFixed
                originalName
              }
            }
          }
        }
      }
    }
  `);
  return (
    <Fragment>
      <TechnicalIcon
        fileEdges={data.allFile.edges}
        imagePath={imageUrl}
      />
    </Fragment>
  )
}

export default queryWrapper;
